import { URL, handleErrors } from "./depannageActions"
import { getParams } from "../../utilities/Addons"
import moment from "moment"
import { catchApiError } from "./apiHelpers"

export const HEURE_TYPE_ATELIER = 0
export const HEURE_TYPE_ENTRETIEN = 1

export const ADD_ATELIER_HEURE = "ADD_ATELIER_HEURE"
export const UPDATE_ATELIER_HEURE = "UPDATE_ATELIER_HEURE"
export const DELETE_ATELIER_HEURE = "DELETE_ATELIER_HEURE"

export const FETCH_HEURES_ATELIER_BEGIN = "FETCH_HEURES_ATELIER_BEGIN"
export const FETCH_HEURES_ATELIER_SUCCESS = "FETCH_HEURES_ATELIER_SUCCESS"
export const FETCH_HEURES_ATELIER_ERROR = "FETCH_HEURES_ATELIER_ERROR"
export const FETCH_HEURES_ATELIER_RESET = "FETCH_HEURES_ATELIER_RESET"

export const fetchHeuresAtelierBegin = () => ({
	type: FETCH_HEURES_ATELIER_BEGIN,
})

export const fetchHeuresAtelierSucces = (payload) => ({
	type: FETCH_HEURES_ATELIER_SUCCESS,
	payload,
})

export const fetchHeuresAtelierError = (payload) => ({
	type: FETCH_HEURES_ATELIER_ERROR,
	payload,
})

export const fetchHeuresAtelierReset = () => ({
	type: FETCH_HEURES_ATELIER_RESET,
})

export function fetchHeuresAtelier(params) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchHeuresAtelierBegin())
		let url = `${URL}api/hours${getParams(params)}`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchHeuresAtelierSucces(json))
			})
			.catch(catchApiError(dispatch, fetchHeuresAtelierError))
	}
}

export const POST_HEURE_ATELIER_BEGIN = "POST_HEURE_ATELIER_BEGIN"
export const POST_HEURE_ATELIER_SUCCESS = "POST_HEURE_ATELIER_SUCCESS"
export const POST_HEURE_ATELIER_ERROR = "POST_HEURE_ATELIER_ERROR"
export const POST_HEURE_ATELIER_RESET = "POST_HEURE_ATELIER_RESET"

export const postHeureAtelierBegin = () => ({
	type: POST_HEURE_ATELIER_BEGIN,
})

export const postHeureAtelierSucces = (payload) => ({
	type: POST_HEURE_ATELIER_SUCCESS,
	payload,
})

export const postHeureAtelierError = (payload) => ({
	type: POST_HEURE_ATELIER_ERROR,
	payload,
})

export const postHeureAtelierReset = () => ({
	type: POST_HEURE_ATELIER_RESET,
})

export function postHeureAtelier(body) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(postHeureAtelierBegin())
		let url = `${URL}api/hours`
		return fetch(url, {
			method: "POST",
			body: JSON.stringify(body),
			headers: { Authorization: `Bearer ${token}` },
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(postHeureAtelierSucces(json))
			})
			.catch(catchApiError(dispatch, postHeureAtelierError))
	}
}

export const getBaseHeure = (type = HEURE_TYPE_ENTRETIEN, employe = 0) => {
	return Object.assign(
		{},
		{
			id: null,
			type,
			atelier: null,
			employe,
			date: moment().format("DD-MM-YYYY"),
			heures: "",
			description: "",
		},
	)
}
